import React, { useEffect, useMemo, useRef, useState } from 'react'
import { Link, useNavigate, useLocation } from 'react-router-dom'
import 'react-toastify/dist/ReactToastify.css';
import { GenderData, GetAllCategory, addToCart } from "../action";
import NavBar from "./NavBar"
import logonew from '../assets/images/logo.svg';
// import logonew from '../assets/images/logonew.png';
import { useDispatch, useSelector } from "react-redux";
import LoginPopup from "./LoginPopup"
import './Header.css';
import SearchBox from "./Common/SearchBox";
import WishlistHeartIcon from "./Common/WishlistHeartIcon";
import debounce from "lodash/debounce";
import axios from "../helper/axios";
import { getCartItemDisplayPrice } from "../helper/discount";

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

export default function Header() {

    const [isHidden, setIsHidden] = useState(false);
    const [loginPopup, setLoginPopup] = useState(false);
    const [showMessage, setShowMessage] = useState(true);
    const stateData = useSelector(state => state);
    const categoryValue = useSelector(state => state?.category);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [searchResults, setSearchResults] = useState([]);
    const [searchBox, setSearchBox] = useState("");
    const [showSearch, setShowSearch] = useState(false);
    const cartCount = useSelector(state => state.productData?.cart?.length);
    const allProduct = useSelector(state => state.productData?.allProduct);
    const productId = useSelector(state => state.productData?.cart);
    const totalPrice = useSelector(state => state.productData?.cart.totalPrice);
    const genderData = useSelector(state => state.category?.gender);
    const wishlistItems = useSelector(state => state.cart?.wishlistItems);
    const cartData = useSelector(state => state.cart?.cartItems);
    const location = useLocation();
    const auth = useSelector(state => state?.productData?.users);
    const allCart = [];
    const [loading, setLoading] = useState(false);

    // === Fresh price data for mini-cart (same rules as /cart) ===
    const [productPriceData, setProductPriceData] = useState({});

    const getProductDetailsForItem = (item) => {
        const productId = item?._id || item?.externalId;
        const loc = item?.location || "";
        return (
            productPriceData[`${productId}::${loc}`] ||
            productPriceData[productId] ||
            null
        );
    };

    const getDisplayPrice = (item) => getCartItemDisplayPrice(item, getProductDetailsForItem(item));

    const validatedMiniTotal = useMemo(() => {
        if (!cartData || cartData.length === 0) return 0;
        let total = 0;
        cartData.forEach((item) => {
            const displayPrice = getDisplayPrice(item);
            const itemPrice = displayPrice.hasDiscount2 && displayPrice.sale2 > 0
                ? displayPrice.sale2
                : (displayPrice.hasDiscount && displayPrice.sale > 0
                    ? displayPrice.sale
                    : displayPrice.regular);
            total += itemPrice * (item.quantity || 1);
        });
        return total;
    }, [cartData, productPriceData]);

    const handleSearch = async (txt) => {
        const q = String(txt || '').trim();
        if (!q || q.length < 2) {
            setSearchResults([]);
            setLoading(false);
            return;
        }

        setLoading(true);
        try {
            const effectiveGender = genderData || undefined;
            const data = {
                brands: [q.toUpperCase()],
                sort: "",
                sizes: [],
                gtPrice: null,
                ltPrice: null,
                catAndGender: effectiveGender,
                page: 0,
                per_page: 10,
                discount: "",
                discountNo: "",
                selectedGender: effectiveGender,
                selectedCat: [],
                newIn: false,
                selectionForYou: false
            };
            const res = await axios.post("/scrollbox", data);

            const root = res?.data?.data ? res.data.data : res?.data;
            const productsRaw =
                (Array.isArray(root) && root) ||
                root?.products ||
                root?.ProductData ||
                root?.data ||
                root?.datax ||
                [];
            const products = (Array.isArray(productsRaw) ? productsRaw : [])
                .filter((p) => p && typeof p === 'object' && !p.msg);
            // Same product can exist in multiple stores (e.g. Mango 053 + 054)
            const deduped = [];
            const seen = new Set();
            for (const p of products) {
                const key = p.externalId ?? p.item_code ?? p._id ?? p.id;
                if (key == null || seen.has(key)) continue;
                seen.add(key);
                deduped.push(p);
            }
            setSearchResults(deduped);
        } catch (err) {
            console.error("Search error:", err);
        }
        setLoading(false);
    };

    // Debounce must always call the latest handleSearch (avoid stale closures)
    const latestSearchHandlerRef = useRef(handleSearch);
    useEffect(() => {
        latestSearchHandlerRef.current = handleSearch;
    }, [handleSearch]);

    const debouncedSearch = useRef(
        debounce((value) => latestSearchHandlerRef.current(value), 500)
    ).current;

    useEffect(() => {
        return () => {
            debouncedSearch.cancel();
        };
    }, [debouncedSearch]);

    // onChange handler
    const handleInputChange = (value) => {
        setSearchBox(value)
        debouncedSearch(value)
    }

    productId?.forEach(crtdt => {
        const cartData = allProduct?.find(dt => dt?._id === crtdt?.productId)
        allCart.push(cartData)
    })

    const ourArray = [1, 4, 0, 9, -3];
    var sum = 0;

    for (let i = 0; i < allCart.length; i += 1) {
        sum += parseFloat(allCart[i]?.regular_price);
    }

    var sum = 0;
    

    const remove = (item) => {
        const sku = item?.item_code;
        const uniqueId = item?.uniqueId;
        const filteredCart = cartData.filter((it) => {
            if (uniqueId && it.uniqueId) return String(it.uniqueId) !== String(uniqueId);
            if (sku) return String(it.item_code) !== String(sku);
            return !(it._id === item?._id && it.size === item?.size);
        });
 
        dispatch(addToCart(filteredCart));
    };

    const cartTotal = (Array.isArray(cartData) ? cartData : []).reduce(
        (acc, item) => acc + (parseFloat(item?.totalPrice) || 0),
        0
    );
    const effectiveCartTotal = Number(
        typeof totalPrice === 'number' && !Number.isNaN(totalPrice)
            ? totalPrice
            : cartTotal
    );

    const RemoveGender = async () => {
        window.scrollTo({ top: 0, left: 0 });
        window.setTimeout(() => window.scrollTo({ top: 0, left: 0 }), 0);
        const gender = null;
        await dispatch(GenderData(gender))
    }


    const chooseGender = async (gender) => {
        window.scrollTo({
            top: 0,
            left: 0,
        });
        await dispatch(GenderData(gender))
        const data = { genderBased: gender }
        await dispatch(GetAllCategory(data));
        navigate("/" + gender);
    }

    const cart = useSelector((state) => state.cart);

    var finalObj = [];

    for (var item in cart.cartItems) {
        finalObj.push(cart.cartItems[item]);
    }

    for (let key in cart.cartItems) {
        sum += cart.cartItems[key].totalPrice * cart.cartItems[key].qty;
    }

    if (cartData.length > 0) {
        var totalCartProduct = cartData.map(item => item.quantity).reduce((prev, next) => prev + next);
    }
    const onSearchClick = () => {
        setShowSearch(!showSearch)
    }
    useEffect(() => {
        setTimeout(() => {
            const searchInput = document.getElementById('search-input')

            if (showSearch && searchInput) searchInput.focus()
        }, 100)
    }, [showSearch]);
    useEffect(() => {
        const getHeader = () => document.querySelector('.header');
        const onScroll = () => {
            const el = getHeader();
            if (!el) return;
            if (window.scrollY > 40) el.classList.add('scrolling-header');
            else el.classList.remove('scrolling-header');
        };
        window.addEventListener('scroll', onScroll, { passive: true });
        onScroll(); // set initial state
        return () => window.removeEventListener('scroll', onScroll);
    }, []);

    // Fetch fresh price data for mini-cart whenever cart items change
    useEffect(() => {
        const fetchFreshPriceData = async () => {
            if (!cartData || cartData.length === 0) {
                setProductPriceData({});
                return;
            }

            try {
                const priceDataMap = {};
                const promises = cartData.map(async (item) => {
                    try {
                        const productId = item?._id || item?.externalId;
                        const dataId = {
                            _id: productId,
                            location: item?.location || ""
                        };
                        const res = await axios.post("/getproductbyid", dataId);
                        if (res?.data?.length > 0) {
                            const preferred =
                                (item?.location &&
                                    res.data.find(
                                        (row) =>
                                            String(row?.productDetails?.location || row?.location || "") ===
                                            String(item.location)
                                    )) ||
                                res.data[0];
                            const productDetails = preferred?.productDetails;
                            priceDataMap[`${productId}::${item?.location || ""}`] = productDetails;
                            priceDataMap[productId] = productDetails;
                        }
                    } catch (error) {
                        console.error(`Error fetching price data for ${item?._id}:`, error);
                    }
                });

                await Promise.all(promises);
                setProductPriceData(priceDataMap);
            } catch (error) {
                console.error("Error fetching fresh price data for header mini-cart:", error);
            }
        };

        fetchFreshPriceData();
    }, [cartData]);

    return (<>
        <div className={'preheader container mx-auto hidden lg:block'}>
            <Link className='imglink hidden lg:inline-block' to="/" onClick={RemoveGender}>
            </Link>
            <ul className='headerlinks flex space-x-1'>
                <li
                    className={`cursor-pointer hover:black text-black font-semibold rounded-sm ${genderData === "female" ? "bg-black text-white hover:bg-black" : "hover:bg-gray-300"}`}
                    onClick={(e) => chooseGender("female")}>
                    FEMËR
                </li>

                <li
                    className={`cursor-pointer hover:black text-black font-semibold rounded-sm ${genderData === "male" ? "bg-black text-white hover:bg-black" : "hover:bg-gray-300"}`}
                    onClick={(e) => chooseGender("male")}>
                    MASHKULL
                </li>

                <li
                    className={`cursor-pointer hover:black text-black font-semibold rounded-sm ${genderData === "kids" ? "bg-black text-white hover:bg-black" : "hover:bg-gray-300"}`}
                    onClick={(e) => chooseGender("kids")}>
                    FËMIJË
                </li>
                {/* <li
                    className={`cursor-pointer hover:black text-black font-semibold rounded-sm ${genderData === "life" ? "bg-black text-white hover:bg-black" : "hover:bg-gray-300"}`}
                    onClick={(e) => chooseGender("life")}>
                    SHTËPI
                </li> */}

                {/* <a href="/brands" onClick={(e) => chooseGender("brand")}>
                    <li
                        className={`cursor-pointer hover:black text-black font-semibold rounded-sm ${genderData === "brand" ? "bg-black text-white hover:bg-black" : "hover:bg-gray-300"}`}>
                        BRENDE
                    </li>
                </a> */}
            </ul>
        </div>
        <header className={`header w-full   ${isHidden ? "header-hide" : "header-show "}`}>
            <nav
                className=" flex flex-col sm:flex-row md:flex-row lg:flex-row xl:flex-row 2xl:flex-row container mx-auto justify-between items-center   sm:w-full md:w-full lg:w-full xl:w-full 2xl:w-12/12 pt-1">
                <Link className='imglink hidden lg:inline-block' to="/" onClick={RemoveGender}>
                    <img src={logonew} className="logo" alt="" srcSet="" />
                </Link>

                {genderData?.length > 0 ? <NavBar onSearch={onSearchClick} /> : <NavBar onSearch={onSearchClick} />}
                <div style={{ flex: 1 }} />


                <div className="  space-x-5 justify-end items-center hidden lg:flex headerrightlinks">
                    <form className="desktop-header-search" method="get" action={`/search/${searchBox}`}>
                        <SearchBox
                            searchBox={searchBox}
                            setSearchBox={handleInputChange}
                            searchResults={searchResults}
                        />
                    </form>
                    <div className="flex items-center space-x-2 header-relative">
                        <Link to="/wishlist" className="hidden md:block">
                            <div className={location.pathname === "/wishlist" ? 'header-active' : ''}>
                                <WishlistHeartIcon
                                  className="header-svg icon icon-tabler icon-tabler-heart"
                                  size={24}
                                  strokeWidth={1.6}
                                  fill="none"
                                />
                            </div>
                        </Link>

                        {wishlistItems && wishlistItems.length > 0 && (
                            <span
                                className="header-active text-white w-1 h-1 flex justify-center items-center bg-red-500 rounded-full mobile-wishlist"
                            >
                                {wishlistItems.length}
                            </span>
                        )}
                    </div>
                    <div className="flex items-center space-x-2 header-relative">

                        {auth?.token && auth?.user ?
                            <Link to="/profile" className="hidden md:block" style={{ whiteSpace: 'nowrap', fontWeight: 300 }}>Hi, {auth?.user?.fname}</Link> : ""
                        }

                        <Link to={(auth?.token && auth?.user ? '/profile' : '/login')} className="hidden md:block">
                            <div className={location.pathname === "/login" ? 'header-active' : ''}>
                                <svg
                                    className={'header-svg'}
                                    width="100mm"
                                    height="100mm"
                                    viewBox="0 0 99.999999 100"
                                    version="1.1"
                                    id="svg1"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <defs
                                        id="defs1">
                                        <clipPath
                                            clipPathUnits="userSpaceOnUse"
                                            id="clipPath511">
                                            <path
                                                d="M 0,319.05 H 325.333 V 0 H 0 Z"
                                                transform="translate(-152.82813,-265.70471)"
                                                id="path511" />
                                        </clipPath>
                                        <clipPath
                                            clipPathUnits="userSpaceOnUse"
                                            id="clipPath513">
                                            <path
                                                d="M 0,319.05 H 325.333 V 0 H 0 Z"
                                                transform="translate(-284.66448,-34.573403)"
                                                id="path513" />
                                        </clipPath>
                                        <clipPath
                                            clipPathUnits="userSpaceOnUse"
                                            id="clipPath515">
                                            <path
                                                d="M 0,298.458 H 336 V 0 H 0 Z"
                                                transform="translate(-117.69713,-245.10741)"
                                                id="path515" />
                                        </clipPath>
                                        <clipPath
                                            clipPathUnits="userSpaceOnUse"
                                            id="clipPath517">
                                            <path
                                                d="M 0,309.125 H 321.333 V 0 H 0 Z"
                                                transform="translate(-163.57373,-255.77881)"
                                                id="path517" />
                                        </clipPath>
                                        <clipPath
                                            clipPathUnits="userSpaceOnUse"
                                            id="clipPath519">
                                            <path
                                                d="M 0,309.125 H 321.333 V 0 H 0 Z"
                                                transform="translate(-163.57373,-207.0924)"
                                                id="path519" />
                                        </clipPath>
                                        <clipPath
                                            clipPathUnits="userSpaceOnUse"
                                            id="clipPath521">
                                            <path
                                                d="M 0,309.125 H 321.333 V 0 H 0 Z"
                                                transform="translate(-89.815502,-60.895402)"
                                                id="path521" />
                                        </clipPath>
                                    </defs>
                                    <g
                                        id="layer1"
                                        transform="translate(-62.177076,-106.09792)">
                                        <g
                                            id="g534"
                                            transform="matrix(0.26458333,0,0,0.26458333,-900.26223,97.980287)">
                                            <path
                                                id="path516"
                                                d="m 0,0 c -61.429,0 -111.401,-49.968 -111.401,-111.392 0,-28.854 10.991,-56.222 30.951,-77.061 1.301,-1.362 2.639,-2.691 4.006,-3.977 20.758,-19.581 47.903,-30.363 76.444,-30.363 28.541,0 55.686,10.782 76.435,30.363 1.376,1.291 2.705,2.615 3.996,3.972 19.979,20.834 30.97,48.198 30.97,77.066 C 111.401,-49.968 61.429,0 0,0 m 0,-232.512 c -31.028,0 -60.546,11.722 -83.107,33.011 -1.481,1.4 -2.933,2.843 -4.357,4.323 -21.707,22.661 -33.657,52.417 -33.657,83.786 0,66.782 54.339,121.111 121.121,121.111 66.782,0 121.121,-54.329 121.121,-121.111 0,-31.388 -11.95,-61.139 -33.657,-83.786 -1.414,-1.48 -2.876,-2.928 -4.376,-4.332 C 60.546,-220.79 31.037,-232.512 0,-232.512"
                                                transform="matrix(1.3333333,0,0,-1.3333333,3826.5423,71.128267)"
                                            />
                                            <path
                                                id="path518"
                                                d="m 0,0 c -20.217,0 -36.656,-16.444 -36.656,-36.651 0,-20.208 16.439,-36.652 36.656,-36.652 20.207,0 36.647,16.444 36.647,36.652 C 36.647,-16.444 20.207,0 0,0 m 0,-83.022 c -25.57,0 -46.375,20.801 -46.375,46.371 0,25.57 20.805,46.37 46.375,46.37 25.57,0 46.366,-20.8 46.366,-46.37 0,-25.57 -20.796,-46.371 -46.366,-46.371"
                                                transform="matrix(1.3333333,0,0,-1.3333333,3826.5423,136.04347)"
                                            />
                                            <path
                                                id="path520"
                                                d="m 0,0 c 20.388,-18.024 46.432,-27.91 73.758,-27.91 27.326,0 53.371,9.886 73.749,27.91 C 132.814,27.174 104.881,43.903 73.758,43.903 42.645,43.903 14.702,27.174 0,0 m 73.758,-37.629 c -31.027,0 -60.546,11.722 -83.107,33.011 l -2.601,2.454 1.566,3.213 c 15.832,32.427 48.075,52.573 84.142,52.573 36.077,0 68.31,-20.146 84.132,-52.573 l 1.567,-3.213 -2.601,-2.454 C 134.304,-25.907 104.795,-37.629 73.758,-37.629"
                                                transform="matrix(1.3333333,0,0,-1.3333333,3728.198,330.9728)"
                                            />
                                        </g>
                                    </g>
                                </svg>
                            </div>
                        </Link>
                    </div>

                    <div className="flex items-center space-x-2">
                        {/*#####################################*/}
                        <div className="relative inline-block text-left">
                            <div className="header-relative test-cart n-ppost cart-dropdown-wrapper">
                                <Link to="/cart" className="cart-icon-link" aria-label="Shporta">
                                    <div className="flex items-center space-x-1">

                                        <svg
                                            width="100mm"
                                            height="100mm"
                                            viewBox="0 0 99.999999 100"
                                            version="1.1"
                                            id="svg1"
                                            xmlns="http://www.w3.org/2000/svg" className={'header-svg'}>
                                            <defs
                                                id="defs1">
                                                <clipPath
                                                    clipPathUnits="userSpaceOnUse"
                                                    id="clipPath511">
                                                    <path
                                                        d="M 0,319.05 H 325.333 V 0 H 0 Z"
                                                        transform="translate(-152.82813,-265.70471)"
                                                        id="path511" />
                                                </clipPath>
                                                <clipPath
                                                    clipPathUnits="userSpaceOnUse"
                                                    id="clipPath513">
                                                    <path
                                                        d="M 0,319.05 H 325.333 V 0 H 0 Z"
                                                        transform="translate(-284.66448,-34.573403)"
                                                        id="path513" />
                                                </clipPath>
                                                <clipPath
                                                    clipPathUnits="userSpaceOnUse"
                                                    id="clipPath515">
                                                    <path
                                                        d="M 0,298.458 H 336 V 0 H 0 Z"
                                                        transform="translate(-117.69713,-245.10741)"
                                                        id="path515" />
                                                </clipPath>
                                                <clipPath
                                                    clipPathUnits="userSpaceOnUse"
                                                    id="clipPath517">
                                                    <path
                                                        d="M 0,309.125 H 321.333 V 0 H 0 Z"
                                                        transform="translate(-163.57373,-255.77881)"
                                                        id="path517" />
                                                </clipPath>
                                                <clipPath
                                                    clipPathUnits="userSpaceOnUse"
                                                    id="clipPath519">
                                                    <path
                                                        d="M 0,309.125 H 321.333 V 0 H 0 Z"
                                                        transform="translate(-163.57373,-207.0924)"
                                                        id="path519" />
                                                </clipPath>
                                                <clipPath
                                                    clipPathUnits="userSpaceOnUse"
                                                    id="clipPath521">
                                                    <path
                                                        d="M 0,309.125 H 321.333 V 0 H 0 Z"
                                                        transform="translate(-89.815502,-60.895402)"
                                                        id="path521" />
                                                </clipPath>
                                                <clipPath
                                                    clipPathUnits="userSpaceOnUse"
                                                    id="clipPath525">
                                                    <path
                                                        d="M 0,300.148 H 353.778 V 0 H 0 Z"
                                                        transform="translate(-120.26063,-55.070201)"
                                                        id="path525" />
                                                </clipPath>
                                                <clipPath
                                                    clipPathUnits="userSpaceOnUse"
                                                    id="clipPath527">
                                                    <path
                                                        d="M 0,300.148 H 353.778 V 0 H 0 Z"
                                                        transform="translate(-245.13983,-54.752299)"
                                                        id="path527" />
                                                </clipPath>
                                            </defs>
                                            <g
                                                id="layer1"
                                                transform="translate(-62.177076,-106.09792)">
                                                <g
                                                    id="g535"
                                                    transform="matrix(0.26458333,0,0,0.26458333,-1017.9576,100.28756)">
                                                    <path
                                                        id="path522"
                                                        d="m 0,0 h 148.807 l 15.737,108.763 -191.272,-0.475 z M 157.217,-9.719 H -7.612 l -38.279,155.09 h -37.064 v 9.719 h 44.676 l 9.15,-37.087 204.911,0.507 z"
                                                        transform="matrix(1.3333333,0,0,-1.3333333,4209.4905,264.962)" />
                                                    <path
                                                        id="path523"
                                                        d="m 0,0 h -157.71 l 20.549,43.096 8.77,-4.186 -13.924,-29.191 H 0 Z"
                                                        transform="matrix(1.3333333,0,0,-1.3333333,4383.7411,326.7704)" />
                                                    <path
                                                        id="path524"
                                                        d="m 0,0 c -4.869,0 -8.827,-3.963 -8.827,-8.832 0,-4.869 3.958,-8.832 8.827,-8.832 4.869,0 8.837,3.963 8.837,8.832 C 8.837,-3.963 4.869,0 0,0 m 0,-27.383 c -10.222,0 -18.546,8.324 -18.546,18.551 0,10.227 8.324,18.551 18.546,18.551 10.232,0 18.556,-8.324 18.556,-18.551 0,-10.227 -8.324,-18.551 -18.556,-18.551"
                                                        transform="matrix(1.3333333,0,0,-1.3333333,4217.2355,326.7704)"
                                                    />
                                                    <path
                                                        id="path526"
                                                        d="m 0,0 c -4.869,0 -8.827,-3.958 -8.827,-8.827 0,-4.869 3.958,-8.832 8.827,-8.832 4.869,0 8.827,3.963 8.827,8.832 C 8.827,-3.958 4.869,0 0,0 m 0,-27.378 c -10.222,0 -18.546,8.324 -18.546,18.551 C -18.546,1.4 -10.222,9.719 0,9.719 10.222,9.719 18.546,1.4 18.546,-8.827 18.546,-19.054 10.222,-27.378 0,-27.378"
                                                        transform="matrix(1.3333333,0,0,-1.3333333,4383.7411,327.19427)"
                                                    />
                                                </g>
                                            </g>
                                        </svg>


                                        {cartData.length > 0 ? (
                                            <span
                                                className="header-active text-white w-1 h-1 flex justify-center items-center bg-red-500 rounded-full mobile-cart"
                                            >
                                                {totalCartProduct > 0 ? totalCartProduct : ''}
                                            </span>
                                        ) : ""}
                                    </div>
                                </Link>
                                {/* Disable mini-cart panel when already on /cart or /checkout */}
                                {!(location.pathname.startsWith('/cart') || location.pathname.startsWith('/checkout')) && (
                                    <div className='cart-product-list n-ppost-name cart-dropdown-panel'>

                                        {(cartData.length > 0 &&
                                            <div
                                                className="cart-dropdown-hm cartbox"
                                                onClick={(e) => e.stopPropagation()}
                                                role="dialog"
                                                aria-label="Përmbajtja e shportës">
                                                <div className="cart-dropdown-hm__inner">
                                                    <h2 className="cart-dropdown-hm__title">Përmbajtja e shportës</h2>

                                                    <ul className="cart-dropdown-hm__list">
                                                        {cartData?.map((dtt, idx) => {
                                                            const qty = dtt?.quantity || 1;
                                                            const displayPrice = getDisplayPrice(dtt);
                                                            const appliedUnitPrice =
                                                                displayPrice.hasDiscount2 && displayPrice.sale2 > 0
                                                                    ? displayPrice.sale2
                                                                    : (displayPrice.hasDiscount && displayPrice.sale > 0
                                                                        ? displayPrice.sale
                                                                        : displayPrice.regular);
                                                            const lineTotal = (appliedUnitPrice * qty).toFixed(2);

                                                            return (
                                                                <li
                                                                    key={(dtt?.name || '') + (dtt?.size || '') + idx}
                                                                    className="cart-dropdown-hm__item"
                                                                >
                                                                    <div className="cart-dropdown-hm__item-img">
                                                                        <img
                                                                            src={dtt?.images?.[0] || 'fallback-image-url.jpg'}
                                                                            alt=""
                                                                        />
                                                                    </div>
                                                                    <div className="cart-dropdown-hm__item-body">
                                                                        <p className="cart-dropdown-hm__item-name">{dtt?.name}</p>
                                                                        <p className="cart-dropdown-hm__item-price">
                                                                            {displayPrice.hasDiscount2 && displayPrice.sale2 > 0 ? (
                                                                                <>
                                                                                    <span className="line-through mr-1">
                                                                                        {displayPrice.regular?.toFixed(2)} {process.env.REACT_APP_CURRENCY}
                                                                                    </span>
                                                                                    {displayPrice.sale > 0 && (
                                                                                        <span className="line-through mr-1">
                                                                                            {displayPrice.sale?.toFixed(2)} {process.env.REACT_APP_CURRENCY}
                                                                                        </span>
                                                                                    )}
                                                                                    <span>
                                                                                        {displayPrice.sale2?.toFixed(2)} {process.env.REACT_APP_CURRENCY}
                                                                                    </span>
                                                                                </>
                                                                            ) : displayPrice.hasDiscount && displayPrice.sale > 0 ? (
                                                                                <>
                                                                                    <span className="line-through mr-1">
                                                                                        {displayPrice.regular?.toFixed(2)} {process.env.REACT_APP_CURRENCY}
                                                                                    </span>
                                                                                    <span>
                                                                                        {displayPrice.sale?.toFixed(2)} {process.env.REACT_APP_CURRENCY}
                                                                                    </span>
                                                                                </>
                                                                            ) : (
                                                                                <span>
                                                                                    {displayPrice.regular?.toFixed(2)} {process.env.REACT_APP_CURRENCY}
                                                                                </span>
                                                                            )}
                                                                        </p>
                                                                        <p className="cart-dropdown-hm__item-meta">
                                                                            Madhësia {dtt?.size} · Sasia {qty}
                                                                        </p>
                                                                        <p className="cart-dropdown-hm__item-total">
                                                                            Total {lineTotal} {process.env.REACT_APP_CURRENCY}
                                                                        </p>
                                                                    </div>
                                                                </li>
                                                            );
                                                        })}
                                                    </ul>

                                                    <div className="cart-dropdown-hm__footer">
                                                        <div className="cart-dropdown-hm__summary">
                                                            <div className="cart-dropdown-hm__summary-row">
                                                                <span>Vlera e porosisë</span>
                                                                <span>{validatedMiniTotal.toFixed(2)} {process.env.REACT_APP_CURRENCY}</span>
                                                            </div>
                                                            <div className="cart-dropdown-hm__summary-row cart-dropdown-hm__summary-row--total">
                                                                <span>TOTAL</span>
                                                                <span>{validatedMiniTotal.toFixed(2)} {process.env.REACT_APP_CURRENCY}</span>
                                                            </div>
                                                        </div>
                                                        <div className="cart-dropdown-hm__actions">
                                                            <Link to="/checkout" className="cart-dropdown-hm__btn cart-dropdown-hm__btn--primary">Checkout</Link>
                                                            <Link to="/cart" className="cart-dropdown-hm__btn cart-dropdown-hm__btn--secondary">Shporta</Link>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </nav>


            {
                showSearch && <div className={'header-search-bar container mx-auto'}>
                    <form method="get" className="flex relative w-full px-3 pb-3" action={`/search/${searchBox}`}>
                        <SearchBox
                            searchBox={searchBox}
                            setSearchBox={handleInputChange}
                            searchResults={searchResults}
                        />
                    </form>
                </div>
            }
        </header>

{/*         
        <div className="albi-promo-stripe-bar">
            <span className="albi-promo-stripe-bar__after">
                <strong> Test Zbritjet</strong> 
            </span>
        </div>
        */}

    </>
    )
}